module.exports = __webpack_public_path__ + "img/who-main_image.f89522c5.png";